import React from 'react';
import { X } from 'lucide-react';

const SizeChartModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose} data-testid="size-chart-modal">
      <div className="bg-white rounded-lg max-w-4xl w-full mx-4 p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-[#1A1A18] hover:text-[#C29B57]"
          data-testid="close-size-chart"
        >
          <X className="w-6 h-6" />
        </button>

        <h2 className="font-cormorant text-3xl mb-6 text-center">Product Measurements</h2>
        <p className="font-outfit text-center text-[#8C8577] mb-8">(For ready-to-wear garments)</p>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[#F3EFE6]">
                <th className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm uppercase tracking-wider">SIZE</th>
                <th className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm uppercase tracking-wider" colSpan="2">BUST</th>
                <th className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm uppercase tracking-wider" colSpan="2">WAIST</th>
                <th className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm uppercase tracking-wider" colSpan="2">HIPS</th>
              </tr>
              <tr className="bg-[#F3EFE6]">
                <th className="border border-[#EBE4D5] px-4 py-2 font-outfit text-xs"></th>
                <th className="border border-[#EBE4D5] px-4 py-2 font-outfit text-xs">In</th>
                <th className="border border-[#EBE4D5] px-4 py-2 font-outfit text-xs">Cm</th>
                <th className="border border-[#EBE4D5] px-4 py-2 font-outfit text-xs">In</th>
                <th className="border border-[#EBE4D5] px-4 py-2 font-outfit text-xs">Cm</th>
                <th className="border border-[#EBE4D5] px-4 py-2 font-outfit text-xs">In</th>
                <th className="border border-[#EBE4D5] px-4 py-2 font-outfit text-xs">Cm</th>
              </tr>
            </thead>
            <tbody>
              {[
                { size: 'XS', bust: ['32"', '81.3'], waist: ['26"', '66'], hips: ['36"', '91.4'] },
                { size: 'S', bust: ['34"', '86.4'], waist: ['28"', '71.1'], hips: ['38"', '96.5'] },
                { size: 'M', bust: ['36"', '91.4'], waist: ['30"', '76.2'], hips: ['40"', '101.6'] },
                { size: 'L', bust: ['38"', '96.5'], waist: ['32"', '81.3'], hips: ['42"', '106.7'] },
                { size: 'XL', bust: ['40"', '101.6'], waist: ['34"', '86.4'], hips: ['44"', '111.8'] },
                { size: 'XXL', bust: ['42"', '106.7'], waist: ['36"', '91.4'], hips: ['46"', '116.8'] },
              ].map((row) => (
                <tr key={row.size} className="hover:bg-[#FCFBF8]">
                  <td className="border border-[#EBE4D5] px-4 py-3 font-outfit font-medium text-center">{row.size}</td>
                  <td className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm text-center">{row.bust[0]}</td>
                  <td className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm text-center">{row.bust[1]}</td>
                  <td className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm text-center">{row.waist[0]}</td>
                  <td className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm text-center">{row.waist[1]}</td>
                  <td className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm text-center">{row.hips[0]}</td>
                  <td className="border border-[#EBE4D5] px-4 py-3 font-outfit text-sm text-center">{row.hips[1]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-6 text-center">
          <p className="font-outfit text-sm text-[#8C8577]">
            For custom measurements, please contact us at{' '}
            <a href="tel:9999633121" className="text-[#C29B57] hover:underline">9999633121</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SizeChartModal;
